import React from 'react';
import PropTypes from 'prop-types';

import {connect, dispatch} from 'utils/state_manager';

import {Box, Button, Stack} from 'views/components';
import {ArrowForwardIos} from 'views/icons';
import {WasHelpfulCard, AiQuestionCard, Translate} from 'views/module';

import {primaryButtonSx} from '../../utils/button_styles';

import HowCallWorks from './cards/HowCallWorks';
import TitleCard from './cards/TitleCard';
import BookCall from './cards/BookCall';

const CareplanStep = (props) => {
  const {onNext, clientRn} = props;

  return (
    <Stack sx={{gap: '8px'}}>
      <TitleCard />
      <HowCallWorks />
      <BookCall />
      <WasHelpfulCard articleTitle="Intake Form | Care Plan | Feedback (Thumbs)" articleRN="RN:ARTICLE-V1-CarePlanHelpful" />
      <AiQuestionCard clientRn={clientRn} page='Intake Form | Care Plan' />

      <Box sx={{textAlign: 'right', mt: '24px'}}>
        <Button
          onClick={onNext}
          sx={primaryButtonSx}
          endIcon={<ArrowForwardIos />}
        >
          <Translate expression={'careplanstep.CareplanStep.NextButton'} />
        </Button>
      </Box>
    </Stack>
  );
};

CareplanStep.propTypes = {
  clientRn: PropTypes.string,
  statusProgressWrap: PropTypes.func.isRequired,
  onNext: PropTypes.func,
};

const mapStateToProps = (state) => ({
  clientRn: state.user.clientRn,
});

export default connect(mapStateToProps, dispatch)(React.memo(CareplanStep));
